window.Popper = require('popper.js').default;
try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import Form from './services/form'
import helper from './services/helper'
import VTooltip from 'v-tooltip'
import VuejsDialog from "vuejs-dialog"
import Loading from 'vue-loading-overlay'
import Vuebar from 'vuebar';
import Notifications from 'vue-notification'
import VueCookie from 'vue-cookie'
import 'vue-loading-overlay/dist/vue-loading.css';
import showTip from './components/show-tip'
import paginationRecord from './components/pagination-record'
import showError from './components/show-error'
import moduleInfo from './components/module-info'
import sortBy from './components/sort-by'
import timepicker from './components/timepicker'
import dateRangePicker from './components/date-range-picker'
import autosizeTextarea from './components/autosize-textarea'
import currencyInput from './components/currency-input'
import uploadImage from './components/upload-image'
import fileUploadInput from './components/file-upload-input'
import imageUploadInput from './components/image-upload-input'
import htmlEditor from './components/html-editor'
import rightPanel from './components/right-panel'
import helpButton from './components/help-button'
import tourNotification from './components/tour-notification'
import vimeoVideo from './components/vimeo-video'
import * as VueGoogleMaps from 'vue2-google-maps'
import firebase from "firebase/app";
import "firebase/messaging";

window.toastr = require('toastr')
window.moment = require('moment')
window._get = require('lodash/get');
window._eachRight = require('lodash/eachRight');
window._replace = require('lodash/replace');
window._has = require('lodash/has');
window._size = require('lodash/size');
window._ = require('lodash');

window.Vue = Vue;
Vue.use(VueRouter);
window.axios = axios;
window.Form = Form;
window.helper = helper;
Vue.prototype.trans = (string, args) => {
    let value = _get(window.i18n, string);

    _eachRight(args, (paramVal, paramKey) => {
        value = _replace(value, `:${paramKey}`, paramVal);
    });
    return value;
};
Vue.prototype.$last = function (item, list) {
  return item == list[list.length - 1]
};
Vue.prototype.$first = function (item, list) {
  return item == list[0]
};

Vue.use(VTooltip);
Vue.use(VuejsDialog);
Vue.use(Loading);
Vue.use(Vuebar);
Vue.use(Notifications);
Vue.use(VueCookie);
Vue.component('show-tip',showTip);
Vue.component('pagination-record',paginationRecord);
Vue.component('show-error',showError);
Vue.component('module-info',moduleInfo);
Vue.component('sort-by',sortBy);
Vue.component('timepicker',timepicker);
Vue.component('date-range-picker',dateRangePicker);
Vue.component('autosize-textarea',autosizeTextarea);
Vue.component('currency-input',currencyInput);
Vue.component('upload-image',uploadImage);
Vue.component('file-upload-input',fileUploadInput);
Vue.component('image-upload-input',imageUploadInput);
Vue.component('html-editor',htmlEditor);
Vue.component('right-panel',rightPanel);
Vue.component('help-button',helpButton);
Vue.component('tour-notification',tourNotification);
Vue.component('vimeo-video',vimeoVideo);
Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.MIX_GOOGLE_MAP_KEY,
      libraries: 'places',
    }
  });
  
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + Vue.cookie.get('auth_token');
const connection =  Vue.cookie.get('x-connection-object')
if(!!connection){
  window.axios.defaults.headers.common['X-Connection-Object'] = connection;
}

axios.interceptors.response.use(response => {
    return response.data
});

var firebaseConfig = {
  apiKey: process.env.MIX_FIREBASE_API_KEY,
  authDomain: process.env.MIX_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.MIX_FIREBASE_DATABASE_URL,
  projectId: process.env.MIX_FIREBASE_PROJECT_ID,
  storageBucket: process.env.MIX_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.MIX_FIREBASE_MESSAGING_SENDERID,
  appId: process.env.MIX_FIREBASE_APPID,
};
  // var firebase = require('firebase');
let userAuth = JSON.parse(window.localStorage.getItem("SchoolPortal"));
if(userAuth.auth.status) {
  // console.log(userAuth.auth.status)
  if(userAuth.auth.roles.includes('admin')) {
    firebase.initializeApp(firebaseConfig);
    if ("Notification" in window) {
      const messaging = firebase.messaging();
      try {
        messaging.getToken({
          vapidKey: process.env.MIX_FIREBASE_VAPIDKEY,
        }).then((currentToken) => {
          if (currentToken) {
            sendTokenToServer(currentToken);
          } else {
            console.warn("Failed to get token.");
          }
        }).catch((err) => {
          console.log("An error occurred while retrieving token. ",err);
          this.setTokenSentToServer(false);
        });
      } catch (e) {
        console.log(e);
      }
      messaging.onMessage((payload) => {
        payload = JSON.parse(payload.data.data);
        console.log("Message received. firebase.js ", payload);
        new Notification(payload.title, {
              body: payload.message,
              icon: payload.image
            });
      });
    }
  }
}
  
  function isTokenSentToServer (currentToken) {
    return (  window.localStorage.getItem("sentFirebaseMessagingToken") ===currentToken);
  }
  function setTokenSentToServer (currentToken) {
    window.localStorage.setItem("sentFirebaseMessagingToken",currentToken ? currentToken : "" );
  }
  function sendTokenToServer (currentToken) {
    if (!isTokenSentToServer(currentToken)) {
      axios.post("/api/admindevice/token", { token: currentToken })
      .then((data) => {
          if (data.status) {
            setTokenSentToServer(currentToken);
          }
      });
    }
  }
/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });



// WEBPACK FOOTER //
// resources/js/bootstrap.js